import { mapGetters } from "vuex";

export default {
    data() {
        return {

        }
    },

    computed: {
        ...mapGetters([
            'activeProductKey',
            'activeOfferKey',
            'activeOffer',
        ]),

        selectedAdditionalAccessoryOption() {
            return this.$store.getters[`${this.activeProductKey}${this.activeOfferKey}CableSelection/base/selectedAdditionalAccessoryOption`];
        },

    },

    methods: {
        additionalAccessoryHandler(option) {
            this.addAdditionalAccessoryToCart(option);
            this.setSelectedAdditionalAccessoryOption(option);
        },

        addAdditionalAccessoryToCart(option) {
            if (this.activeOffer.oneToOneAccessory.positive_conditions.includes(option) && !this.activeOffer.included.includes(this.activeOffer.oneToOneAccessory.accessory.name)) {
                this.activeOffer.included.push(this.activeOffer.oneToOneAccessory.accessory.name);
                this.activeOffer.productCodes.push(this.activeOffer.oneToOneAccessory.accessory.code);
            } else if (!this.activeOffer.oneToOneAccessory.positive_conditions.includes(option) && this.activeOffer.included.includes(this.activeOffer.oneToOneAccessory.accessory.name)) {
                this.activeOffer.included.pop();
                this.activeOffer.productCodes.pop();
            }
        },

        setSelectedAdditionalAccessoryOption(option) {
            return this.$store.commit(`${this.activeProductKey}${this.activeOfferKey}CableSelection/base/setSelectedAdditionalAccessoryOption`, option);
        },
    },
}